import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <FaqSection />
        <CommentsSection />
        <IndexSection />
        <CarouselSection />
        <FeaturesSection />
        <TopicsSection />
        <AppSection />
        <RankingSection />
        <CardsSection />
        <AboutSection />
        <UpdatesSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}